import { analytics, auth, functions } from "./config";
import refs from "./refs";

export default {
  async authorize() {
    if (auth.currentUser) {
      console.log("already authorized");
      return;
    }
    await auth.signInAnonymously().catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log("error", errorCode, errorMessage);
      analytics.logEvent("auth_error", {
        error_code: errorCode,
        error_message: errorMessage,
      });
    });
    console.log("signed in");
    auth.onAuthStateChanged(async function(user) {
      if (user) {
        console.log("user signed in");
      } else {
        console.log("user signed out");
        // User is signed out.
        // ...
      }
    });
  },
  async addPlayer(gameId, player) {
    console.log("adding");
    return await functions.httpsCallable("addPlayer")({
      gameId: gameId,
      player: player,
    });
  },
  // Could randomize players here, but may need a transaction to ensure player trying to enter doesn't get kicked out
  async startGame(gameId) {
    console.log("got here");
    var players = await this.getPlayers(gameId);
    await refs
      .playerInfo(gameId)
      .update({ currentPlayer: players[0], counter: 0 });
    await refs.state(gameId).set("started");
    await refs.roundCount(gameId).set(1);
  },
  async getPlayers(gameId) {
    var players = [];
    await refs.players(gameId).once("value", (snapshot) => {
      snapshot.forEach((player) => {
        players.push({
          player: player.val().player,
          playerKey: player.ref.key,
        });
      });
    });

    return players;
  },
};
